//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/TaggedObjectList.js";
import "../no/SelectNXObjectList.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"ComplexPoint",0,"SelectNXObject",0],[1,"SegPairList",0,"TaggedObjectList",0],[1,"SegmentPair",0,"SelectNXObjectList",0],[1,"SimplePoint",0,"Routing.RouteObjectCollector",0],[0,"Type",1,0]],[[[],"SegmentPairBuilder",{R_:{builder:"Routing.SegmentPairBuilder"}},0,0]],[]];
SPLM.Routing.AssignDiscontinuityBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.AssignDiscontinuityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.AssignDiscontinuityBuilder.Types = Object.freeze({
    "Simple" : "Simple", "Complex" : "Complex"});

export default SPLM;